import { EVENT_STATUS } from "../../utilities/enums";

const PriceGuard = {
  state: {
    market_data: [],
  },
  mutations: {
    expireStoredPrices(state, args) {
      let currentTime = new Date().getTime();
      state.market_data = state.market_data.reduce((final, next) => {
        let lastReceived = currentTime - next.client_timestamp;
        let priceExpired = lastReceived >= args.dataExpirationCycle;
        let priceIsIgnored = next.status == EVENT_STATUS.IGNORE;
        let alreadyExpired = next.status == EVENT_STATUS.EXPIRED;
        let removePriceAfter =
          args.removeExpiredDataAfter + args.dataExpirationCycle;
        if (args.removeExpiredData && lastReceived > removePriceAfter) {
          return final;
        } else {
          if (priceExpired & !priceIsIgnored & !alreadyExpired) {
            next.status = EVENT_STATUS.EXPIRED;
            final.push(JSON.parse(JSON.stringify(next)));
          } else {
            final.push(next);
          }
        }
        return final;
      }, []);
    },
    changeItemStatus(state, { itemToChange, newStatus }) { // This function changes status of an item
      let index = state.market_data.findIndex(el => el.id == itemToChange.id)
      if(index == -1) return;
      // Get and remove the item to update from market data 
      let updatedItem = state.market_data.splice(index, 1)[0]
      let cleanUpdatedItem = JSON.parse(JSON.stringify(updatedItem))
      cleanUpdatedItem.status = newStatus

      if(newStatus == EVENT_STATUS.IGNORE) state.market_data.push(cleanUpdatedItem)
      else state.market_data.unshift(cleanUpdatedItem)
    },

    updateStoredPGMarketData(state, new_market_data) {
      // Combine new_market_data with the items from state.market_data that do not exist in new_market_data
      // state.market_data = new data + old data unincluded symbols from new data
      state.market_data = new_market_data.concat(
        state.market_data.filter((el) => {
          return (
            new_market_data.findIndex((price) => {
              return price.id == el.id;
            }) == -1
          );
        })
      );
    },

    clearMarketData(state) {
      state.market_data = [];
    },
    deleteItemFromMarketData(state, itemToDelete) {
      state.market_data = state.market_data.filter(
        (item) => !(itemToDelete.id == item.name + item.identity + item.symbol)
      );
    },
  },
  actions: {
    clearMarketData({ commit }, event) {
      commit("removePriceEvent", event);
    },
  },
  getters: {
    getPriceGuardEvents: (state) => {
      return state.market_data;
    },
  },
};
export default PriceGuard;
